import React from "react";
import PropTypes from "prop-types";

import "./index.scss";

export default function SelectableUserList({
    items = [],
    selectedIds = [],
    onToggle,
    emptyMessage = "No items",
    isLoading = false,
    disabled = false,
}) {
    if (isLoading) {
        return <p className="selectable-user-list__meta">Loading…</p>;
    }

    if (!items.length) {
        return <p className="selectable-user-list__meta">{emptyMessage}</p>;
    }

    return (
        <ul className={`selectable-user-list ${disabled ? 'is-disabled' : ''}`}>
            {items.map((item) => {
                const isSelected = selectedIds.includes(item.id);
                return (
                    <li key={item.id} className={`selectable-user-list__item ${isSelected ? "is-selected" : ""}`}>
                        <button
                            type="button"
                            className="selectable-user-list__button"
                            onClick={() => !disabled && onToggle(item.id)}
                            disabled={disabled}
                        >
                            <span className="selectable-user-list__name">{item.title}</span>
                            {item.subtitle && <span className="selectable-user-list__subtitle">{item.subtitle}</span>}
                            <span className="selectable-user-list__checkbox" aria-hidden="true">
                                {isSelected ? "✓" : "+"}
                            </span>
                        </button>
                    </li>
                );
            })}
        </ul>
    );
}

SelectableUserList.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        subtitle: PropTypes.string,
    })),
    selectedIds: PropTypes.arrayOf(PropTypes.string),
    onToggle: PropTypes.func.isRequired,
    emptyMessage: PropTypes.string,
    isLoading: PropTypes.bool,
    disabled: PropTypes.bool,
};
